export default __webpack_public_path__ + "static/media/facebook-logo.bf60f269.svg";